export const isTestDomain = () => {
  return ['localhost', 'parcel2go.test.p2g.ninja'].includes(window.location.hostname);
};
